import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
  setCurrentQueryParam as setCurrentQueryParamAction,
  clearCurrentQueryParam as clearCurrentQueryParamAction,
  selectCurrentQuery,
} from '#/trip-planner/slice';

export default () => {
  const dispatch = useDispatch();
  const currentQuery = useSelector(selectCurrentQuery, shallowEqual);
  const clearCurrentQueryParam = useCallback(
    key => dispatch(clearCurrentQueryParamAction(key)),
    [dispatch]
  );
  const setCurrentQueryParam = useCallback(
    (key, value) => dispatch(setCurrentQueryParamAction({ [key]: value })),
    [dispatch]
  );

  const setMultiCurrentQueryParams = useCallback(
    currentQueryParams =>
      dispatch(setCurrentQueryParamAction(currentQueryParams)),
    [dispatch]
  );

  return {
    clearCurrentQueryParam,
    setCurrentQueryParam,
    setMultiCurrentQueryParams,
    currentQuery,
  };
};
